//const backendDomain = "http://192.168.1.190/sridhar_official";
const backendDomain = "https://sridhardental.com";

const SummaryApi = {
  SendMail: { 
    url: `${backendDomain}/mail/sendmail.php`, 
    method: "POST" 
  },
};

export default SummaryApi;
